<template>
    <v-card tile>
        <v-card-title class="body-3">
            <div class="headerClass">
                {{data.title}}
            </div>
        </v-card-title >
        <v-card-subtitle>
            {{getAuthor()}}
        </v-card-subtitle>
        <v-divider/>
        <v-card-actions>
          <v-text-field
            v-if="showPriorityField"
              type="number"
              flat
              hint="Priority"
              prepend-inner-icon="mdi-counter"
              persistent-hint
              v-model="data.order"
              @keydown.enter="onPriorityChange"
              class="shrink"
            ></v-text-field >
            <v-spacer/>
            <v-btn
              text
              color="primary"
              @click="editArticle"
            >
              <v-icon>{{ icons.edit }}</v-icon>
            </v-btn>
            <v-btn
              text
              color="primary"
              @click.stop="showDeleteDialog=true"
            >
                <v-icon>{{ icons.delete }}</v-icon>
            </v-btn>
        </v-card-actions>
        <DeleteDialog :data="{id:data.id}" :visible="showDeleteDialog" @close="showDeleteDialog=false" @confirmAction="deletingImage"/>
        <PriorityConfirmDialog @continue ="priorityChangeConfirmed" :data="priorityDialogData" :visible="showPriorityDialog" @close="closePriorityDialog" />

    </v-card>
</template>
<script>
import DeleteDialog from '@/components/ConfirmDeleteDialog.vue'
import snackbar from '@/utils/snackbar'
import postApi from '@/api/postApi'
import { mdiPencil, mdiDelete } from '@mdi/js'
import PriorityConfirmDialog from '@/components/PriorityConfirmDialog.vue'
import * as postType from '@/constants/PostType'

export default {
  components: {
    DeleteDialog,
    PriorityConfirmDialog
  },
  data () {
    return {
      icons: {
        edit: mdiPencil,
        delete: mdiDelete
      },
      oldOrder: null,
      showPriorityDialog: false,
      showDeleteDialog: false,
      loading: false,
      // this is sent to server when updating prioirty
      priorityParams: {
        id: null,
        publish_date: null,
        order: null,
        type: postType.TYPE_ARTICLE
      },
      priorityDialogData: {
        message: null,
        id: null,
        order: null,
        // for reassigning if priority assignment dialog is cancelled
        oldOrder: null
      }
    }
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    showPriorityField: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  mounted () {
    this.priorityDialogData.oldOrder = this.data.order
    this.priorityParams.id = this.data.id
    this.priorityParams.publish_date = this.data.publish_date
    this.priorityParams.oldOrder = this.data.order
    this.oldOrder = this.data.order
  },
  methods: {

    closePriorityDialog (params) {
      this.showPriorityDialog = false
      if (params !== undefined) {
        // assigned old order since dialog has been cancelled
        this.data.order = params.oldOrder
      }
    },
    priorityChangeConfirmed (data) {
      // when confirm button is clicked
      this.$log.info('priority change confirmed ', [data])
      this.$emit('priorityChanged', { id: this.data.id, priority: parseInt(this.data.order) })
    },
    async onPriorityChange (e) {
      this.$log.info('article card  on priority change', [this.priorityParams])
      if (this.data.order === '') {
        snackbar.show('Enter a valid priority value', 'error')
        return
      }
      this.priorityParams.order = this.data.order
      this.cardLoading = true
      try {
        const response = await postApi.assignOrderPriority(this.priorityParams)
        this.$log.info('Response assign priority', [response.data])
        if (response.data !== undefined) {
          if (response.data.status === 'success') {
            snackbar.show('Priority changed successfully', 'success')
            this.$emit('priorityChanged')
          } else if (response.data.status === 'fail') {
            this.priorityDialogData.message = response.data.error_message
            this.showPriorityDialog = true
            this.data.order = this.oldOrder
          }
        }
      } finally {
        this.cardLoading = false
      }
    },
    async deletingImage (data) {
      if (data !== null && data.id !== undefined) {
        const id = data.id
        this.loading = true
        try {
          const result = await postApi.deleteArticle(id)
          if (result.data === 'success') {
            snackbar.show('Article deleted successfully', 'success')
            this.$emit('delete_success')
          }
        } finally {
          this.loading = false
        }
      }
    },
    editArticle () {
      this.$router.push({ path: '/article/edit/' + this.data.id })
    },
    getAuthor () {
      if (this.data !== undefined) {
        if (this.data.guest_writer !== undefined &&
                Array.isArray(this.data.guest_writer) &&
                this.data.guest_writer.length > 0) {
          return 'Guest Writer - ' + this.data.guest_writer[0].name
        } else if (
          this.data.public_writer !== undefined &&
          Array.isArray(this.data.public_writer) &&
          this.data.public_writer.length > 0
        ) {
          return 'Public Writer - ' + this.data.public_writer[0].name
        }
      }
      return 'N/A'
    }
  }
}
</script>

<style scoped>
.headerClass{
    white-space: nowrap ;
    word-break: normal;
    overflow: hidden ;
    text-overflow: ellipsis;
}
</style>
